import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { ArrowRightLeft } from 'lucide-react';
import { qrPost } from './qrApi';
import { adminGet } from '../adminApi';
import { Button } from '@/components/ui/button';

/** Track0tic admin: move a device to another customer. Refused while open bindings exist; cross-pod needs the checklist tick. */
export function ReallocateDevice({ deviceId, onDone }) {
  const [open, setOpen] = useState(false);
  const [tenants, setTenants] = useState([]);
  const [to, setTo] = useState('');
  const [checklist, setChecklist] = useState(null);
  const [ticked, setTicked] = useState(false);
  useEffect(() => { if (open) adminGet('/customers?limit=200').then(r => setTenants(r.items || r)).catch(() => setTenants([])); }, [open]);
  const go = async () => {
    try {
      const r = await qrPost(`/devices/${deviceId}/reallocate`, { tenant_id: to, ack_checklist: ticked });
      toast.success(`Moved to ${r.to}${r.cross_pod ? ' (cross-pod)' : ''}`); setOpen(false); setChecklist(null); onDone?.();
    } catch (e) {
      let d = null; try { d = JSON.parse(e.message); } catch { /* plain */ }
      if (e.status === 428 && d?.checklist) setChecklist(d); else toast.error(e.message || 'Reallocation refused');
    }
  };
  return (
    <div className="mt-4" data-testid="device-reallocate">
      {!open && <Button data-testid="device-reallocate-btn" size="sm" variant="outline" className="h-8 gap-1 border-[#D9D6CD]" onClick={() => setOpen(true)}><ArrowRightLeft size={14} /> Reallocate to another customer</Button>}
      {open && (
        <div className="rounded border p-3 space-y-2" style={{ borderColor: '#D9D6CD' }}>
          <select data-testid="device-reallocate-tenant" value={to} onChange={e => { setTo(e.target.value); setChecklist(null); setTicked(false); }} className="h-8 rounded border px-2 text-sm bg-white w-full" style={{ borderColor: '#D9D6CD' }}>
            <option value="">Choose customer…</option>{tenants.map(t => <option key={t.id} value={t.id}>{t.legal_name || t.name}</option>)}
          </select>
          {checklist && (
            <div className="rounded p-3 text-xs space-y-1" style={{ background: '#FFF7E6' }} data-testid="device-reallocate-checklist">
              <p className="font-semibold">Cross-pod move ({checklist.from_pod} → {checklist.to_pod}) — certificate revoke/reissue is a manual step</p>
              <ol className="list-decimal pl-4">{checklist.checklist.map(c => <li key={c}>{c}</li>)}</ol>
              <a href={checklist.runbook} target="_blank" rel="noreferrer" className="underline">Runbook</a>
              <label className="flex items-center gap-2 mt-1"><input type="checkbox" data-testid="device-reallocate-ack" checked={ticked} onChange={e => setTicked(e.target.checked)} /> I have completed the checklist</label>
            </div>)}
          <div className="flex gap-2">
            <Button data-testid="device-reallocate-confirm" size="sm" className="h-8 text-white" style={{ background: '#0B6B55' }} disabled={!to || (checklist && !ticked)} onClick={go}>Move device</Button>
            <Button size="sm" variant="outline" className="h-8" onClick={() => { setOpen(false); setChecklist(null); }}>Cancel</Button>
          </div>
        </div>)}
    </div>
  );
}
